{
  "REPORT": {
    "HEADER": "대화",
    "LOADING_CHART": "차트 데이터 불러오는 중...",
    "NO_ENOUGH_DATA": "보고서를 생성할 수 있는 데이터 포인트가 부족합니다. 나중에 다시 시도하십시오.",
    "DOWNLOAD_CONVERSATION_REPORTS": "대화 보고서 다운로드",
    "DATA_FETCHING_FAILED": "데이터를 가져오지 못했습니다. 나중에 다시 시도하십시오.",
    "SUMMARY_FETCHING_FAILED": "요약을 가져오지 못했습니다. 나중에 다시 시도하십시오.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "대화",
        "DESC": "( 총 )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "수신 메시지",
        "DESC": "( 총 )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "발신 메시지",
        "DESC": "( 총 )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "첫 번째 응답 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "첫 번째 응답 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_TIME": {
        "NAME": "해결 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "해결 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "해결 수",
        "DESC": "( 총 )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "해결 수",
        "DESC": "( 총 )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "핸드오프 수",
        "DESC": "( 총 )"
      },
      "REPLY_TIME": {
        "NAME": "고객 대기 시간",
        "TOOLTIP_TEXT": "대기 시간은 {metricValue}입니다 ({conversationCount}개 응답 기준)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "지난 7일",
      "LAST_14_DAYS": "지난 14일",
      "LAST_30_DAYS": "지난 30일",
      "THIS_MONTH": "이번 달",
      "LAST_MONTH": "지난 달",
      "LAST_3_MONTHS": "지난 3개월",
      "LAST_6_MONTHS": "지난 6개월",
      "LAST_YEAR": "지난 1년",
      "CUSTOM_DATE_RANGE": "사용자 지정 날짜 범위"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "적용",
      "PLACEHOLDER": "날짜 범위 선택"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "그룹 기준",
    "DURATION_FILTER_LABEL": "기간",
    "GROUPING_OPTIONS": {
      "DAY": "일",
      "WEEK": "주",
      "MONTH": "월",
      "YEAR": "년"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "일"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "일"
      },
      {
        "id": 2,
        "groupBy": "주"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "일"
      },
      {
        "id": 2,
        "groupBy": "주"
      },
      {
        "id": 3,
        "groupBy": "월"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "주"
      },
      {
        "id": 3,
        "groupBy": "월"
      },
      {
        "id": 4,
        "groupBy": "년"
      }
    ],
    "BUSINESS_HOURS": "영업시간",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "필터 지우기",
      "EMPTY_LIST": "검색 결과가 없습니다"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "더 불러오기",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "미배정",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "{total}개 결과 중 {start}~{end} 표시",
      "PER_PAGE_TEMPLATE": "{size} / 페이지"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "에이전트 개요",
    "DESCRIPTION": "대화, 응답 시간, 해결 시간, 해결된 케이스 등 주요 지표로 에이전트 성과를 쉽게 추적할 수 있습니다. 에이전트 이름을 클릭하면 자세한 내용을 확인할 수 있습니다.",
    "LOADING_CHART": "차트 데이터 불러오는 중...",
    "NO_ENOUGH_DATA": "보고서를 생성할 수 있는 데이터 포인트가 부족합니다. 나중에 다시 시도하십시오.",
    "DOWNLOAD_AGENT_REPORTS": "에이전트 보고서 다운로드",
    "FILTER_DROPDOWN_LABEL": "에이전트 선택",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "에이전트 검색"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "대화",
        "DESC": "( 총 )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "수신 메시지",
        "DESC": "( 총 )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "발신 메시지",
        "DESC": "( 총 )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "첫 번째 응답 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "첫 번째 응답 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_TIME": {
        "NAME": "해결 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "해결 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "해결 수",
        "DESC": "( 총 )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "지난 7일"
      },
      {
        "id": 1,
        "name": "지난 30일"
      },
      {
        "id": 2,
        "name": "지난 3개월"
      },
      {
        "id": 3,
        "name": "지난 6개월"
      },
      {
        "id": 4,
        "name": "지난 1년"
      },
      {
        "id": 5,
        "name": "사용자 지정 날짜 범위"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "적용",
      "PLACEHOLDER": "날짜 범위 선택"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "라벨 개요",
    "DESCRIPTION": "대화, 응답 시간, 해결 시간, 해결된 케이스 등 주요 지표로 라벨 성과를 추적할 수 있습니다. 라벨 이름을 클릭하면 자세한 내용을 확인할 수 있습니다.",
    "LOADING_CHART": "차트 데이터 불러오는 중...",
    "NO_ENOUGH_DATA": "보고서를 생성할 수 있는 데이터 포인트가 부족합니다. 나중에 다시 시도하십시오.",
    "DOWNLOAD_LABEL_REPORTS": "라벨 보고서 다운로드",
    "FILTER_DROPDOWN_LABEL": "라벨 선택",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "라벨 검색"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "대화",
        "DESC": "( 총 )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "수신 메시지",
        "DESC": "( 총 )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "발신 메시지",
        "DESC": "( 총 )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "첫 번째 응답 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "첫 번째 응답 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_TIME": {
        "NAME": "해결 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "해결 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "해결 수",
        "DESC": "( 총 )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "지난 7일"
      },
      {
        "id": 1,
        "name": "지난 30일"
      },
      {
        "id": 2,
        "name": "지난 3개월"
      },
      {
        "id": 3,
        "name": "지난 6개월"
      },
      {
        "id": 4,
        "name": "지난 1년"
      },
      {
        "id": 5,
        "name": "사용자 지정 날짜 범위"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "적용",
      "PLACEHOLDER": "날짜 범위 선택"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "받은 메시지함 개요",
    "DESCRIPTION": "대화, 응답 시간, 해결 시간, 해결된 케이스 등 주요 지표로 받은 메시지함 성과를 한눈에 확인할 수 있습니다. 받은 메시지함 이름을 클릭하면 자세한 내용을 확인할 수 있습니다.",
    "LOADING_CHART": "차트 데이터 불러오는 중...",
    "NO_ENOUGH_DATA": "보고서를 생성할 수 있는 데이터 포인트가 부족합니다. 나중에 다시 시도하십시오.",
    "DOWNLOAD_INBOX_REPORTS": "받은 메시지함 보고서 다운로드",
    "FILTER_DROPDOWN_LABEL": "받은 메시지함 선택",
    "ALL_INBOXES": "모든 받은 메시지함",
    "SEARCH_INBOX": "받은 메시지함 검색",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "받은 메시지함 검색"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "대화",
        "DESC": "( 총 )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "수신 메시지",
        "DESC": "( 총 )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "발신 메시지",
        "DESC": "( 총 )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "첫 번째 응답 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "첫 번째 응답 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_TIME": {
        "NAME": "해결 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "해결 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "해결 수",
        "DESC": "( 총 )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "지난 7일"
      },
      {
        "id": 1,
        "name": "지난 30일"
      },
      {
        "id": 2,
        "name": "지난 3개월"
      },
      {
        "id": 3,
        "name": "지난 6개월"
      },
      {
        "id": 4,
        "name": "지난 1년"
      },
      {
        "id": 5,
        "name": "사용자 지정 날짜 범위"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "적용",
      "PLACEHOLDER": "날짜 범위 선택"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "팀 개요",
    "DESCRIPTION": "대화, 응답 시간, 해결 시간, 해결된 케이스 등 필수 지표로 팀 성과를 한눈에 확인할 수 있습니다. 팀 이름을 클릭하면 자세한 내용을 확인할 수 있습니다.",
    "LOADING_CHART": "차트 데이터 불러오는 중...",
    "NO_ENOUGH_DATA": "보고서를 생성할 수 있는 데이터 포인트가 부족합니다. 나중에 다시 시도하십시오.",
    "DOWNLOAD_TEAM_REPORTS": "팀 보고서 다운로드",
    "FILTER_DROPDOWN_LABEL": "팀 선택",
    "FILTERS": {
      "ADD_FILTER": "필터 추가",
      "CLEAR_ALL": "모두 지우기",
      "NO_FILTER": "사용 가능한 필터가 없습니다",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "팀 검색"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "대화",
        "DESC": "( 총 )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "수신 메시지",
        "DESC": "( 총 )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "발신 메시지",
        "DESC": "( 총 )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "첫 번째 응답 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "첫 번째 응답 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_TIME": {
        "NAME": "해결 시간",
        "DESC": "( 평균 )",
        "INFO_TEXT": "계산에 사용된 총 대화 수:",
        "TOOLTIP_TEXT": "해결 시간은 {metricValue}입니다 ({conversationCount}개 대화 기준)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "해결 수",
        "DESC": "( 총 )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "지난 7일"
      },
      {
        "id": 1,
        "name": "지난 30일"
      },
      {
        "id": 2,
        "name": "지난 3개월"
      },
      {
        "id": 3,
        "name": "지난 6개월"
      },
      {
        "id": 4,
        "name": "지난 1년"
      },
      {
        "id": 5,
        "name": "사용자 지정 날짜 범위"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "적용",
      "PLACEHOLDER": "날짜 범위 선택"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT 보고서",
    "NO_RECORDS": "아직 응답이 없습니다",
    "NO_RECORDS_DESCRIPTION": "고객이 피드백을 제공하기 시작하면 CSAT 설문 응답이 여기에 표시됩니다.",
    "DOWNLOAD": "CSAT 보고서 다운로드",
    "DOWNLOAD_FAILED": "CSAT 보고서 다운로드에 실패했습니다",
    "FILTERS": {
      "ADD_FILTER": "필터 추가",
      "CLEAR_ALL": "모두 지우기",
      "NO_FILTER": "사용 가능한 필터가 없습니다",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "에이전트 검색",
        "INBOXES": "받은 메시지함 검색",
        "TEAMS": "팀 검색",
        "RATINGS": "평점 검색"
      },
      "AGENTS": {
        "LABEL": "에이전트"
      },
      "INBOXES": {
        "LABEL": "받은 메시지함"
      },
      "TEAMS": {
        "LABEL": "팀"
      },
      "RATINGS": {
        "LABEL": "평점"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "연락처",
        "AGENT_NAME": "에이전트",
        "RATING": "평점",
        "FEEDBACK_TEXT": "피드백 코멘트",
        "CONVERSATION": "대화",
        "CUSTOMER": "고객",
        "RESPONSE": "응답",
        "HANDLED_BY": "담당자"
      },
      "UNKNOWN_CUSTOMER": "알 수 없는 고객"
    },
    "NO_AGENT": "배정된 에이전트 없음",
    "NO_FEEDBACK": "피드백이 제공되지 않았습니다",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "총 응답 수",
        "TOOLTIP": "수집된 총 응답 수"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "만족도 점수",
        "TOOLTIP": "긍정적 응답 수 / 총 응답 수 * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "응답률",
        "TOOLTIP": "총 응답 수 / 발송된 CSAT 설문 메시지 수 * 100"
      },
      "RATING_DISTRIBUTION": "평점 분포"
    },
    "REVIEW_NOTES": {
      "TITLE": "리뷰 메모",
      "PLACEHOLDER": "이 평점에 대한 리뷰 메모를 추가하십시오...",
      "SAVE": "저장",
      "CANCEL": "취소",
      "SAVING": "저장 중...",
      "SAVED": "메모가 성공적으로 저장되었습니다",
      "SAVE_ERROR": "메모 저장에 실패했습니다",
      "UPDATED_BY": "{name}이(가) {time}에 업데이트함",
      "UPDATED_BY_LABEL": "업데이트한 사람",
      "PAYWALL": {
        "TITLE": "리뷰 메모를 추가하려면 업그레이드하십시오",
        "AVAILABLE_ON": "리뷰 메모 기능은 Business 및 Enterprise 플랜에서만 사용할 수 있습니다.",
        "UPGRADE_PROMPT": "리뷰 메모를 통해 모든 CSAT 응답에 내부 컨텍스트를 추가할 수 있습니다. 실제 상황을 기록하고, 패턴을 빠르게 파악하며, 피드백을 기반으로 더 나은 결정을 내리십시오.",
        "UPGRADE_NOW": "지금 업그레이드",
        "CANCEL_ANYTIME": "언제든지 플랜을 변경하거나 취소할 수 있습니다"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "봇 보고서",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "대화 수",
        "TOOLTIP": "봇이 처리한 총 대화 수"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "총 응답 수",
        "TOOLTIP": "봇이 보낸 총 응답 수"
      },
      "RESOLUTION_RATE": {
        "LABEL": "해결률",
        "TOOLTIP": "봇이 해결한 대화 수 / 봇이 처리한 총 대화 수 * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "핸드오프율",
        "TOOLTIP": "에이전트에게 전달된 대화 수 / 봇이 처리한 총 대화 수 * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "개요",
    "LIVE": "실시간",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "열린 대화",
      "LOADING_MESSAGE": "대화 지표 불러오는 중...",
      "OPEN": "열림",
      "UNATTENDED": "미응대",
      "UNASSIGNED": "미배정",
      "PENDING": "보류 중"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "대화 트래픽",
      "NO_CONVERSATIONS": "대화 없음",
      "CONVERSATION": "{count}개 대화",
      "CONVERSATIONS": "{count}개 대화",
      "DOWNLOAD_REPORT": "보고서 다운로드"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "해결",
      "NO_CONVERSATIONS": "대화 없음",
      "CONVERSATION": "{count}개 대화",
      "CONVERSATIONS": "{count}개 대화",
      "DOWNLOAD_REPORT": "보고서 다운로드"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "에이전트별 대화",
      "LOADING_MESSAGE": "에이전트 지표 불러오는 중...",
      "NO_AGENTS": "에이전트별 대화가 없습니다",
      "TABLE_HEADER": {
        "AGENT": "에이전트",
        "OPEN": "열림",
        "UNATTENDED": "미응대",
        "STATUS": "상태"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "모든 팀",
      "HEADER": "팀별 대화",
      "LOADING_MESSAGE": "팀 지표 불러오는 중...",
      "NO_TEAMS": "사용 가능한 데이터가 없습니다",
      "TABLE_HEADER": {
        "TEAM": "팀",
        "OPEN": "열림",
        "UNATTENDED": "미응대",
        "STATUS": "상태"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "에이전트 상태",
      "ONLINE": "온라인",
      "BUSY": "바쁨",
      "OFFLINE": "오프라인"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "일요일",
    "MONDAY": "월요일",
    "TUESDAY": "화요일",
    "WEDNESDAY": "수요일",
    "THURSDAY": "목요일",
    "FRIDAY": "금요일",
    "SATURDAY": "토요일"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA 보고서",
    "NO_RECORDS": "SLA가 적용된 대화가 없습니다.",
    "LOADING": "SLA 데이터 불러오는 중...",
    "DOWNLOAD_SLA_REPORTS": "SLA 보고서 다운로드",
    "DOWNLOAD_FAILED": "SLA 보고서 다운로드에 실패했습니다",
    "DROPDOWN": {
      "ADD_FIlTER": "필터 추가",
      "CLEAR_ALL": "모두 지우기",
      "CLEAR_FILTER": "필터 지우기",
      "EMPTY_LIST": "검색 결과가 없습니다",
      "NO_FILTER": "사용 가능한 필터가 없습니다",
      "SEARCH": "필터 검색",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA 이름",
        "AGENTS": "에이전트 이름",
        "INBOXES": "받은 메시지함 이름",
        "LABELS": "라벨 이름",
        "TEAMS": "팀 이름"
      },
      "SLA": "SLA 정책",
      "INBOXES": "받은 메시지함",
      "AGENTS": "에이전트",
      "LABELS": "라벨",
      "TEAMS": "팀"
    },
    "WITH": "포함",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "달성률",
        "TOOLTIP": "생성된 SLA 중 성공적으로 완료된 비율"
      },
      "NO_OF_MISSES": {
        "LABEL": "미달성 수",
        "TOOLTIP": "특정 기간 내 총 SLA 미달성 수"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "대화 수",
        "TOOLTIP": "SLA가 적용된 총 대화 수"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "정책",
        "CONVERSATION": "대화",
        "AGENT": "에이전트"
      },
      "VIEW_DETAILS": "상세 보기"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "받은 메시지함",
    "AGENT": "에이전트",
    "TEAM": "팀",
    "LABEL": "라벨",
    "AVG_RESOLUTION_TIME": "평균 해결 시간",
    "AVG_FIRST_RESPONSE_TIME": "평균 첫 번째 응답 시간",
    "AVG_REPLY_TIME": "평균 고객 대기 시간",
    "RESOLUTION_COUNT": "해결 수",
    "CONVERSATIONS": "대화 수"
  }
}
